import { Link } from '@mui/material';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import TableChart from '@mui/icons-material/TableChart';
import Description from '@mui/icons-material/Description';
import Code from '@mui/icons-material/Code';
import OpenInNew from '@mui/icons-material/OpenInNew';
import React from 'react';
import PropTypes from 'prop-types';
import config from '../../api/config';

const fileIconMap = {
  pdf: PictureAsPdf,
  xlsx: TableChart,
  xls: TableChart,
  doc: Description,
  docx: Description,
  json: Code,
  xml: Code,
};

function getFileIcon(href) {
  const ext = href.split('.').pop().toLowerCase().split('?')[0];
  const Icon = fileIconMap[ext];
  return Icon ? <Icon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'middle' }} /> : null;
}

function matchesKnownPrefix(href) {
  try {
    const url = new URL(href);
    return (config.aiFilesPrefix || []).some((prefix) => {
      const basePath = prefix.replace(/\*$/, '');
      return url.pathname.startsWith(basePath);
    });
  } catch {
    return false;
  }
}

function AIFileLink({ href, children, ...rest }) {
  const isKnownPrefix = matchesKnownPrefix(href);

  let finalHref = href;
  if (isKnownPrefix) {
    const token = window.sessionStorage.getItem('token') || window.localStorage.getItem('token');
    if (token) {
      const separator = href.includes('?') ? '&' : '?';
      finalHref = `${href}${separator}access_token=${encodeURIComponent(token)}`;
    }
  }

  const icon = getFileIcon(href);

  return (
    <Link
      href={finalHref}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {icon}
      {children}
      <OpenInNew sx={{ fontSize: 14, ml: 0.3, verticalAlign: 'middle', opacity: 0.6 }} />
    </Link>
  );
}

AIFileLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};

AIFileLink.defaultProps = {
  href: '',
  children: null,
};

export default AIFileLink;